import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ShoppingCart } from 'lucide-react';
import { gradientPillCss } from '../../styles/gradientPill';

type FloatingCartFabProps = {
  readonly itemCount: number;
  readonly onOpen: () => void;
};

const Button = styled.button`
  ${gradientPillCss};
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  z-index: 64;
  border: 0;
  min-height: auto;
  padding: 0.58rem 0.82rem;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-weight: 800;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.24);
  cursor: pointer;

  @media (max-width: 1080px) {
    display: none;
  }
`;

const Badge = styled.span`
  min-width: 18px;
  height: 18px;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.16);
  color: #111827;
  font-size: 0.75rem;
  line-height: 18px;
  text-align: center;
  font-weight: 700;
`;

export default function FloatingCartFab({ itemCount, onOpen }: FloatingCartFabProps) {
  const [isMobileViewport, setIsMobileViewport] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const mediaQuery = window.matchMedia('(max-width: 1080px)');
    const syncViewport = () => setIsMobileViewport(mediaQuery.matches);

    syncViewport();
    mediaQuery.addEventListener('change', syncViewport);

    return () => mediaQuery.removeEventListener('change', syncViewport);
  }, []);

  if (itemCount <= 0 || isMobileViewport) return null;

  return (
    <Button type="button" onClick={onOpen} aria-label="Open cart">
      <ShoppingCart size={16} />
      Cart
      <Badge>{itemCount}</Badge>
    </Button>
  );
}
